import { AppShell, Group, Image } from '@mantine/core'
import { FC } from 'react'
import * as classes from './TopBar.module.css'
import logo from '../../../static/logo_orikami.svg'

const TopBar: FC = () => {
  return (
    <AppShell.Header className={classes.header}>
      <Group pl="lg">
        <Image
          className={classes.logo}
          src={logo}
          alt="Orikami Logo"
          fit="contain"
          h={48}
          w={200}
        />
      </Group>
    </AppShell.Header>
  )
}

export default TopBar
